/** MySQL database connection details for a DatabaseConnector task. */
export class MySqlConnectionConfig {
	/** Database server hostname or IP. @default '' */
	host = '';
	/** Server port. @default 3306 */
	port = 3306;
	/** Database username. Supports expression syntax. @default '' */
	username = '';
	/** Database password. Supports expression syntax. @default '' */
	password = '';
	/** Target database/schema name. @default '' */
	databaseName = '';

	constructor(init?: Partial<MySqlConnectionConfig>) {
		Object.assign(this, init);
	}
}
